<template>
  <div class="crowdorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="vipMember" v-if="total <= 0">
      <img class="avater" :src="userData.avatar"/>
      <span>{{userData.username}} </span>
      <p @click="goMember">开通会员 <i class="el-icon-arrow-right"></i></p>
    </div>
    <div class="vipMember" v-if="total > 0">
      <img class="avater" :src="userData.avatar" />
      <span>{{userData.username}} </span>
      <p>{{arr.endtime}} 到期</p>
      <img class="vipimg" src="~assets/images/vipimg.png" />
    </div>
    <div class="head">
      <img src="~assets/img3/a1.png"/>
      <ul>
        <li @click="$router.push('mwallet')">
          <h2>{{price}}<font>元</font></h2>
          <p>累计收益</p>
        </li>
        <li>
          <h2>{{finance.length > 0 ? finance[0].price : 0.00}}<font>元</font></h2>
          <p>近期收入</p>
        </li>
        <li @click="$router.push('movies')" class="last">
          <h2>1<font>GO</font></h2>
          <p>兑换电影票</p>
        </li>
        <li @click="goCrowd">
          <h2>1<font>GO</font></h2>
          <p>投资咖啡吧</p>
        </li>
        <li @click="clickCrowd(mall)">
          <h2>1<font>GO</font></h2>
          <p>{{mall == 0 ? '申请开店' : '我的咖啡吧'}}</p>
        </li>
        <li @click="$router.push('detail?id=6')" class="last">
          <h2>1<font>GO</font></h2>
          <p>外卖咖啡吧</p>
        </li>
      </ul>
    </div>
    <div class="inp">
      <input type="text" v-model="orderSN" placeholder="输入咖啡订单号,购买后十五分钟即可领取">
      <a @click="saveOrder">提交</a>
      <div style="clear:both"></div>
    </div>
    <div class="member" v-if="total <= 0" id="mb">
      <h3>会员开通</h3>
      <ul>
        <li style="background: #FDECEE;border:solid 1px #E34D59" @click="dialogVisible = true" v-if="cbid > 0">
          <div class="left">
            <span><i>￥</i>0.00</span>
            <span>指定会员</span>
          </div>
          <div class="right">
            <h2>定制咖啡机会员卡</h2>
            <p>购买咖啡，扫码提交商户单号，单单返现</p>
            <p>返现金额：上不封顶</p>
          </div>
          <a>领取</a>
        </li>
        <li v-for="(item,i) in setMember" @click="toPush(item.id,'mdetail?oid='+id)">
          <div class="left">
            <span><i>￥</i>{{item.rate}}</span>
            <span>{{item.status == 1 ? '周卡' : item.status == 2 ? '月卡' : item.status == 3?'季度卡':item.status == 4?'年卡':'日卡'}}</span>
          </div>
          <div class="right">
            <h2>{{item.title}}</h2>
            <p>{{item.briefly}}</p>
            <p>返现金额：{{item.rebate}}元</p>
          </div>
          <a>抢购</a>
        </li>
      </ul>
    </div>
    <div class="runing">
      <h2>返现流水</h2>
      <ul>
        <li v-for="(item,i) in finance">{{item.createtime}}
          <font v-if="item.status == 1">￥{{item.price}}</font>
          <font v-if="item.status == 2">景区门票</font>
        </li>
      </ul>
    </div>
    <el-dialog title="领取会员" :visible.sync="dialogVisible" width="85%" :show-close="false" :center="true">
      <dl>
        <dd v-if="t == 1">
          <span>验证码</span>
          <input type="text" placeholder="请输入验证码领取" v-model="code"/>
        </dd>

        <dd v-if="t == 2">
          <span>姓名</span>
          <input type="text" placeholder="请输入姓名激活" v-model="name"/>
        </dd>
        <dd v-if="t == 2">
          <span>手机号</span>
          <input type="text" placeholder="请输入手机号激活" v-model="phone"/>
        </dd>
      </dl>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMember">{{t == 1 ? '领 取' :'激 活'}}</el-button>
      </span>
      <img @click="dialogVisible = false" style="position:absolute;bottom:-70px;left:50%;width:35px;transform: translateX(-50%);cursor: pointer;" src="~assets/images/close.png">
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        dialogVisible:false,
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        total:0,
        arr:[],
        finance:[],
        price:0.00,
        near:0.00,
        orderSN:'',
        code:'',
        setMember:[],
        mall:0,
        cbid:0,
        t:'',
        code:'',
        name:'',
        phone:'',
      };
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/crowdorder');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.t = this.$route.query.t > 0 ? this.$route.query.t : '';
      this.cbid = this.$route.query.id > 0 ? this.$route.query.id : 0;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getMember();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      saveMember:function(){
        var that = this;
        if(that.t == 1){
          if(that.code == ''){
            that.$alert('请输入验证码领取', '提示');
            return false;
          }
        }else if(that.t == 2){
          if(that.name == ''){
            that.$alert('请输入姓名激活', '提示');
            return false;
          }
          if(that.phone == ''){
            that.$alert('请输入手机号激活', '提示');
            return false;
          }
        }
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/crowd/saveMember',
          data:{
            code:that.code,
            name:that.name,
            phone:that.phone,
            id:that.cbid,
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            that.fullscreenLoading = false;
            if(data.status == 200){
              that.getDetail();
              that.dialogVisible = false;
            }else{
              that.$alert(data.message, '提示');
            }
          }
        })
      },
      goMember:function(){
        document.querySelector('#mb').scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      },
      clickCrowd:function(id){
        if(id == 0){
          window.location.href = 'tel://18580092850';
        }else{
          this.$router.push({
            path:'detail',
            query:{
              id:id
            }
          })
        }
      },
      goCrowd:function(){
        window.location.href="http://user.4008005216.com/main/crowd";
      },
      saveOrder:function(){
        var that = this;
        if(that.orderSN == ''){
          that.$alert('请输入订单编号', '提示');
          return false;
        }
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/crowd/crowdOrder',
          data:{
            orderId:that.orderSN,
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            that.fullscreenLoading = false;
            if(data.status == 200){
              that.getDetail();
            }else{
              that.$alert(data.message, '提示');
            }
          }
        })
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getMember:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/menber'
        }).then(function(response){
          var res = response.data;
          that.setMember = res.data
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getDetail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/isUser',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.total = res.data.total;
          that.arr = res.data.rs == null ? [] : res.data.rs;
          that.getRinance();
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getRinance:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/walletTotal',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.finance = res.data.rs;
          that.mall = res.data.mall;
          that.price = res.data.price;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.getDetail();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .crowdorderApp{
    background:#ebebeb;
  }
  
  .crowdorderApp .vipMember{
    height:40px;
    width:100%;
    background:rgba(255,255,255,0.8)
  }
  .crowdorderApp .vipMember .avater{
    width:25px;
    height:25px;
    border-radius:50%;
    float:left;
    margin:7px 0 0 4%
  }
  .crowdorderApp .vipimg{
    position:absolute;
    top:6px;
    left:8%;
    width:15px
  }
  .crowdorderApp .vipMember span{
    float:left;
    height:40px;
    line-height:40px;
    font-weight:500;
    font-size:15px;
    color:#000;
    margin-left:10px
  }
  .crowdorderApp .vipMember p{
    font-size:15px;
    padding-left:10px;
    float:right;
    margin-right:4%;
    height:40px;
    line-height:40px;
    color:#666
  }
  .crowdorderApp .head{
    width:100%;
    font-size:0
  }
  .crowdorderApp .head img{
    width:100%;
  }
  .crowdorderApp .head ul{
    background:#fff;
    font-size:15px;
    display: grid;
    grid-template-columns: repeat(3, 33.3%);
  }
  .crowdorderApp .head ul li{
    text-align:center;
    padding:10px 0;
    position:relative
  }
  .crowdorderApp .head ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:20px;
    background:#ccc;
    border-radius:1px;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .crowdorderApp .head ul li.last:after{
    width:0
  }
  .crowdorderApp .head ul li h2{
    font-size:18px;
    color:#502b05
  }
  .crowdorderApp .head ul li h2 font{
    font-size:12px;
    font-weight:normal;
  }
  .crowdorderApp .head ul li p{
    font-size:13px;
    color:#666;
    padding-top:3px
  }
  .crowdorderApp .runing h2{
    text-align:center;
    color:#404040;
    font-size:30px;
    font-weight:normal;
    padding-bottom:15px
  }
  .crowdorderApp .runing ul{
    background:#fff;
  }
  .crowdorderApp .runing li{
    height:50px;
    line-height:50px;
    width:92%;
    margin: 0 auto;
    border-bottom:solid 1px #f1f1f1;
    color:#666;
    font-size:15px;
  }
  .crowdorderApp .runing li:last-child{
    border-bottom:none;
  }
  .crowdorderApp .runing li font{
    float:right;
    color:#000
  }
  .crowdorderApp .inp{
    padding:30px 0;
    width:92%;
    margin:0 auto
  }
  .crowdorderApp .inp input{
    width:75%;
    height:45px;
    border-radius:10px 0 0 10px ;
    border:solid 1px #502b05;
    outline:none;
    font-size:14px;
    padding:0 3%;
    float:left
  }
  .crowdorderApp .inp a{
    width:18%;
    background:#502b05;
    height:47px;
    line-height:45px;
    text-align:center;
    color:#fff;
    border-radius: 0 10px 10px 0;
    float:left
  }
  .crowdorderApp .member h3{
    text-align:center;
    color:#404040;
    font-size:30px;
    font-weight:normal;
    padding-bottom:15px
  }
  .crowdorderApp .member ul{
    width:100%;
    display:block;
    margin:0 auto;
  }
  .crowdorderApp .member ul li{
    background:#fff;
    margin-bottom:15px;
    position:relative;
    border-radius:6px;
    padding:15px 0
  }
  .crowdorderApp .member ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .crowdorderApp .member ul li .left{
    float:left;
    width:22%;
  }
  .crowdorderApp .member ul li .left span{
    display:block;
    background:#502b05;
    border-radius:5px;
    width:83%;
    text-align:center;
    color:#fff;
    font-size:12px;
    margin-left:auto;
  }
  .crowdorderApp .member ul li .left span:first-child{
    height:45px;
    line-height:45px;
    font-size:17px;
    font-weight:bold
  }
  .crowdorderApp .member ul li .left span:last-child{
    height:25px;
    line-height:25px;
    position:relative;
  }
  .crowdorderApp .member ul li .left span:last-child:after{
    content:'';
    position:absolute;
    border-top:#e7ce98 dashed 1px;
    width:88%;
    height:1px;
    left:50%;
    transform: translateX(-50%);
    top:-1px
  }
  .crowdorderApp .member ul li .left span i{
    font-size:12px;
    font-weight:400
  }
  .crowdorderApp .member ul li .right{
    float:left;
    width:70%;
    margin-left:3%
  }
  .crowdorderApp .member ul li .right h2{
    font-size:15px;
    color:#502b05
  }
  .crowdorderApp .member ul li .right p{
    font-size:13px;
    color:#666;
    padding-top:8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width:70%
  }
  .crowdorderApp .member  ul li a{
    position:absolute;
    right:4%;
    bottom:20px;
    color:#fff;
    background:#502b05;
    border-radius: 30px;
    width: 63px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }

  .crowdorderApp .el-dialog{
    border-radius: 10px;
    margin-top:60% !important
  }
  .crowdorderApp .el-dialog--center .el-dialog__body{
    padding: 0px 25px 0px;
  }
  .crowdorderApp .el-dialog .dialog-footer button{
    height: 40px;
    background: #F2F4F7;
    border-radius: 8px;
    color: #000000;
    font-weight: 500;
    font-size:15px;
    width:45%;
    border-color:#F2F4F7;
  }
  .crowdorderApp .el-dialog .dialog-footer button:last-child{
    background: #0059D6;
    color:#fff;
    border-color:#0059D6;
  }

  .crowdorderApp .el-dialog dd{
    widht:100%;
    height:50px;
    margin-bottom:12px;
  }
  .crowdorderApp .el-dialog dl{
    padding:20px 0
  }
  .crowdorderApp .el-dialog dd span{
    float:left;
    width:20%;
    height:50px;
    line-height:50px;
    font-size:15px;
    color:#333
  }
  .crowdorderApp .el-dialog dd input{
    width:74%;
    height:50px;
    line-height:50px;
    border:none;
    background: #F2F4F7;
    border-radius:8px;
    font-size:15px;
    padding:0 3%;
    outline:none;
  }

</style>